import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const WordPress = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Looking for reliable WordPress Development Services in India? We build fast, secure, and stunning websites. Contact us to start your project!"
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="WordPress Development Services Company in India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/wordpress"
        />
        <meta
          property="og:description"
          content="Looking for reliable WordPress Development Services in India? We build fast, secure, and stunning websites. Contact us to start your project!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="WordPress Development Services Company in India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Looking for reliable WordPress Development Services in India? We build fast, secure, and stunning websites. Contact us to start your project!"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/wordpress" />
        <title>
          WordPress Development Services Company in India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6">
        <div className=" p-4 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 lg:text-left ">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                WordPress Development Company in India
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Transform your online presence with Ayanshtech Solutions, a
                leading WordPress Development Company in India. Our expert
                developers craft visually stunning, responsive, and
                high-performance websites tailored to your brand’s goals.
                <br />
                <br />
                From custom WordPress theme design to plugin development, API
                integrations, and speed optimization, we deliver end-to-end
                WordPress solutions that enhance user experience and boost your
                business growth.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\softwareDev\wordpress\img1.jpg"
                alt="WordPress Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center  p-4">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our WordPress Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Unlock the full potential of WordPress to build websites that are
            secure, scalable, and customized to meet your business goals.
          </p>
        </div>

        <div className=" p-4 mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom Theme Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Plugin Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Third-Party Integrations</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Support and Maintenance</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Performance Optimization</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Enhanced Security Features</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Website Migration Services</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Mobile-Friendly Design</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 p-4 mt-8">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our WordPress Development Services?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our team of WordPress experts ensures your website is built with
            precision, focusing on performance, aesthetics, and scalability.
          </p>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\softwareDev\wordpress\img2.webp"
                alt="WordPress Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon9.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable solutions for growing businesses
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon10.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Fully customizable designs and features
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Enhanced user experience for better engagement
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Reliable security to protect your data
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AyanshtechAdvantage />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default WordPress;
